import { render, staticRenderFns } from "./NsLogo.vue?vue&type=template&id=0ec1a221&scoped=true&"
import script from "./NsLogo.vue?vue&type=script&lang=js&"
export * from "./NsLogo.vue?vue&type=script&lang=js&"
import style0 from "./NsLogo.vue?vue&type=style&index=0&id=0ec1a221&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec1a221",
  null
  
)

export default component.exports